import builderPathInit from '../../util/builder-path-init';

const { BuilderPage, getServerSideProps } = builderPathInit({
    model: 'business-page',
    pathPrefix: 'business',
});
export default BuilderPage;
export { getServerSideProps };